
import { Route } from '@/app/router'

const Locations = () => import('./index.vue')

const LocationsMeta = {
	sort: 12,
	displayInSidebar: true,
	displayName: 'location',
	icon: 'fal forklift',
	activeIcon: 'fas forklift'
}

const LocationsProps = ['page', 'perPage']

export default new Route('/locations', Locations)
	.as('Dashboard:Locations')
	.meta(LocationsMeta)
	.props(LocationsProps)
	.permissions(['VIEW_LOCATION'])
